import { CSS as RadioCSS } from '../../components/input/radio.input.style';
import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-DepartmentSelector',
	btn: 'c-DepartmentSelector__Btn',
	icon: 'c-DepartmentSelector__Icon',
	department: 'c-DepartmentSelector__Department',
	departmentOptions: 'c-DepartmentSelector__Options',
	departmentOption: 'c-DepartmentSelector__Option',
	departmentDisabled: 'c-DepartmentSelector__Department__Disabled',
};

export const Style = {
	[CSS.container]: {
		position: 'relative',
	},
	[CSS.btn]: {
		display: 'flex',
		'align-items': 'center',
		'max-width': '300px',
		'text-transform': 'none',
	},
	[CSS.department]: {
		margin: `0 ${DefaultTheme.space(2)}`,
		color: DefaultTheme.font.color.white,
		'font-weight': DefaultTheme.font.weight.normal,
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
	},
	[CSS.departmentOptions]: {
		width: '600px',
		display: 'flex',
		'flex-direction': 'column',
		[`& .${RadioCSS.container}`]: {
			cursor: 'pointer',
			'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
			color: DefaultTheme.font.color.primary,
		},
		[`& .${RadioCSS.container}:hover`]: {
			'background-color': DefaultTheme.background.lightGrey,
		},
	},
	[CSS.departmentDisabled]: {
		color: DefaultTheme.font.color.error,
	},
};
